import React, { useState, createContext, useContext } from "react";
import {
  ITripDateRange,
  defaultFavoriteDateRange,
  defaultPastDateRange,
  defaultUpcomingDateRange,
} from "../types/TripTypes";
import {
  Tabs,
  defaultCurrentPage,
  defaultForceRefetch,
  defaultPageSize,
  defaultRowsToSkip,
  defaultSortOrder,
  defaultTripTypes,
} from "../types/TripPaginationFilterTypes";

export const DashboardContext = createContext<any | undefined>(undefined);

export const useDashboardCtx = () => useContext(DashboardContext);

export const DashboardProvider: React.FC = ({ children }) => {
  const [activeTab, setActiveTab] = useState<string>(Tabs.UPCOMING);

  // pagination
  const [pageSize, setPageSize] = useState<{ [tab: string]: number }>(
    defaultPageSize
  );
  const [currentPage, setCurrentPage] = useState<{ [tab: string]: number }>(
    defaultCurrentPage
  );
  const [rowsToSkip, setRowsToSkip] = useState<{ [tab: string]: number }>(
    defaultRowsToSkip
  );

  // sort
  const [sortOrder, setSortOrder] = useState<{ [tab: string]: string }>(
    defaultSortOrder
  );

  // filters
  const [selectedPersonId, setSelectedPersonId] = useState<string>("");
  const [upcomingDateRange, setUpcomingDateRange] = useState<ITripDateRange>(
    defaultUpcomingDateRange
  );
  const [showDateRange, setShowDateRange] = useState<ITripDateRange>(
    defaultUpcomingDateRange
  );
  const [pastDateRange, setPastDateRange] = useState<ITripDateRange>(
    defaultPastDateRange
  );
  const [favoriteDateRange, setFavoriteDateRange] = useState<ITripDateRange>(
    defaultFavoriteDateRange
  );
  const [tripTypes, setTripTypes] = useState<{
    [tab: string]: Set<string>;
  }>(defaultTripTypes);
  const [showCanceled, setShowCanceled] = useState<boolean>(false);
  const [forceRefetch, setForceRefetch] = useState<{ [tab: string]: boolean }>(
    defaultForceRefetch
  );
  const [showTabs, setShowTabs] = useState<boolean>(false);


  const resetFavoritePagination = () => {
    setRowsToSkip((prev) => ({
      ...prev,
      [Tabs.FAVORITE]: 0,
    }));
    setCurrentPage((prev) => ({
      ...prev,
      [Tabs.FAVORITE]: 1,
    }));
    setForceRefetch((prev) => ({
      ...prev,
      [Tabs.FAVORITE]: !prev[Tabs.FAVORITE],
    }));
  };

  const resetPagination = () => {
    setActiveTab(Tabs.UPCOMING);
    setShowCanceled(false);
    setRowsToSkip(defaultRowsToSkip);
    setPageSize(defaultPageSize);
    setCurrentPage(defaultCurrentPage);
    setSelectedPersonId("");
    setTripTypes(defaultTripTypes);
    setSortOrder(defaultSortOrder);
    setUpcomingDateRange(defaultUpcomingDateRange);
    setPastDateRange(defaultPastDateRange);
    setFavoriteDateRange(defaultPastDateRange);
    setShowDateRange(defaultUpcomingDateRange)
  };

  return (
    <DashboardContext.Provider
      value={{
        resetPagination,
        resetFavoritePagination,
        selectedPersonIdCtx: [selectedPersonId, setSelectedPersonId],
        forceRefetchCtx: [forceRefetch, setForceRefetch],
        pageSizeCtx: [pageSize, setPageSize],
        activeTabCtx: [activeTab, setActiveTab],
        sortOrderCtx: [sortOrder, setSortOrder],
        tripTypesCtx: [tripTypes, setTripTypes],
        rowsToSkipCtx: [rowsToSkip, setRowsToSkip],
        currentPageCtx: [currentPage, setCurrentPage],
        showCanceledCtx: [showCanceled, setShowCanceled],
        pastDateRangeCtx: [pastDateRange, setPastDateRange],
        upcomingDateRangeCtx: [upcomingDateRange, setUpcomingDateRange],
        favoriteDateRangeCtx: [favoriteDateRange, setFavoriteDateRange],
        showTabsCtx : [showTabs, setShowTabs],
        showDateRangeCtx :[showDateRange, setShowDateRange],
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};
